import React, { useRef, useState } from 'react'
import { FaPlay, FaStopCircle } from 'react-icons/fa';
import { CiPause1 } from 'react-icons/ci';
import ReactPlayer from 'react-player';


const HomeScrollSectionTwo = () => {
    const [playing, setPlaying] = useState(false);
    const playerRef = useRef(null);

    const handleStop = () => {
        setPlaying(false);
        playerRef.current.seekTo(0);
    };

    return (
        <>
            <div id="section-two" className="background-container d-flex justify-content-center align-items-center">
                <video className="background-video" autoPlay muted loop>
                    <source src="/video/home1.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <main className="main-section">
                    <h1 className='text_36_home text-black'>Virtual Assistant Introduction </h1>
                    <div className="avatar-container">
                        <ReactPlayer
                            ref={playerRef}
                            url={'/video/home2.mp4'}
                            playing={playing}
                        />
                    </div>
                    <div className="video-controls">
                        <button className="control-button text-white play" aria-label="Play"
                            onClick={() => setPlaying(true)}
                        ><FaPlay /></button>
                        <button className="control-button text-white pause" aria-label="Pause"
                            onClick={() => setPlaying(false)}><CiPause1 /></button>
                        <button className="control-button text-white stop" aria-label="Stop"
                            onClick={handleStop} ><FaStopCircle /></button>
                    </div>
                </main>

                <aside className="progress-indicator">
                    <div className="indicator-item active"></div>
                    <div className="indicator-item"></div>
                    <div className="indicator-item"></div>
                </aside>
            </div>
        </>
    )
}

export default HomeScrollSectionTwo



